import { render } from "./MemoForm.vue?vue&type=template&id=ae2ed64c&scoped=true&ts=true"
import script from "./MemoForm.vue?vue&type=script&lang=ts"
export * from "./MemoForm.vue?vue&type=script&lang=ts"

import "./MemoForm.vue?vue&type=style&index=0&id=ae2ed64c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2ed64c"]])

export default __exports__